export function exists(val: string | null): boolean {
  return val !== null || !!val;
}

export default exists;
